import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
  useHover,
  useInteractions,
} from '@floating-ui/react';
import React, { useState } from 'react';
import styles from './HoverButton.module.scss';

const HoverButton = ({ buttonContent, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-end',
    whileElementsMounted: autoUpdate,
    middleware: [offset(5), flip({ padding: 10 }), shift({ padding: 10 })],
  });

  const hover = useHover(context, { delay: { open: 50, close: 200 } });

  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

  return (
    <div className={styles.wrapper}>
      <span
        ref={refs.setReference}
        {...getReferenceProps()}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-controls={isOpen ? context.floatingId : undefined}
        aria-label="Menu trigger"
      >
        {buttonContent}
      </span>
      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          className={styles.menu}
          {...getFloatingProps()}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default HoverButton;
